<template>
  <ul v-if="TLDRArray.length" class="tldr__wrapper">
    <li
      class="tldr__item subtitle-5"
      :class="dynamicClasses"
      v-for="(tldr, i) in TLDRArray"
      :key="`${tldr}${i}`"
    >
      {{ tldr }}
    </li>
  </ul>
</template>

<script>
import { propValidator, PROP_TYPES } from '@/utils/validators'

export default {
  name: 'ATldr',
  props: {
    tldr: propValidator([PROP_TYPES.STRING], false),
    fontBold: propValidator([PROP_TYPES.BOOLEAN], false, true),
    itemsToShow: propValidator([PROP_TYPES.NUMBER], false)
  },
  data() {
    return {}
  },
  computed: {
    TLDRArray() {
      try {
        const tldr = JSON.parse(this.tldr)
        if (!Array.isArray(tldr)) return []

        const tldrWithoutEmptyValues = tldr.filter(v => v !== '')
        return this.itemsToShow
          ? tldrWithoutEmptyValues.slice(0, this.itemsToShow)
          : tldrWithoutEmptyValues
      } catch (err) {
        this.$errorHandler(err, this, { showMessage: false })
        return []
      }
    },
    dynamicClasses() {
      return [{ bold: this.fontBold }]
    }
  },
  mounted() {
    this.$emit('mounted')
  }
}
</script>

<style lang="scss" scoped>
.tldr__wrapper {
  .tldr__item {
    color: $c--gray-dark;
    list-style-type: none;
    margin-bottom: 5px;
    font-weight: 400;
    position: relative;

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
